import React, { useState } from 'react';
import { Page, Text, View, Document, StyleSheet, PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import PayoffSchedulePDF from './PayoffSchedulePDF'
import PayoffSummaryPDF from './PayoffSummaryPDF'


export default function PayoffPDF(props) {
    return (
        <PDFViewer width="100%" height="100%">
        <Document>
        <PayoffSchedulePDF schedule={props.schedules.schedule}></PayoffSchedulePDF>
        <PayoffSummaryPDF summary={props.schedules.summary}></PayoffSummaryPDF>
        </Document>
        </PDFViewer>
        // <PDFDownloadLink fileName="Debt Payoff Schedule.pdf" document={
        //     <Document>
        //         <PayoffSchedulePDF schedule={props.schedules.schedule}></PayoffSchedulePDF>
        //         <PayoffSummaryPDF summary={props.schedules.summary}></PayoffSummaryPDF>
        //     </Document>
        // }
        // >
        //     Download
        // </PDFDownloadLink>

    );
}

